angular.module('env.data.rest', [

    'env.data.rest.model',
    'env.data.rest.modelPool',
    'env.data.rest.restProvider',

    'env.data.rest.signalR'

]);